import useFiltersQueryParams from "hooks/useFiltersQueryParams";
import React from "react";

const MainSortMarketplace = ({ makeSound }) => {
  const { searchParams, setQueryParam } = useFiltersQueryParams();

  const sortForOffer = () => {
    makeSound();
    setQueryParam("status", "not_sale,not_owned");
  };

  const sortForSell = () => {
    makeSound();
    setQueryParam("status", "owned,not_sale");
  };

  const sellForBuy = () => {
    makeSound();
    setQueryParam("status", "not_owned,for_sale");
  };

  const getActiveClass = (paramsValue) => {
    const value = decodeURIComponent(searchParams.toString())
    return value.includes(paramsValue) ? 'active' : ''
  }


  return (
    <div className="gradient-block__marketplace-sort">
      <button
        className={`gradient-block__search-popup-link ${getActiveClass('status=not_sale,not_owned')}`}
        onClick={sortForOffer}
      >
        Make Offer
      </button>
      <button
        className={`gradient-block__search-popup-link ${getActiveClass('status=owned')}`}
        onClick={sortForSell}
      >
        Sell
      </button>
      <button
        className={`gradient-block__search-popup-link ${getActiveClass('status=not_owned,for_sale')}`}
        onClick={sellForBuy}
      >
        Buy
      </button>
    </div>
  );
};

export default MainSortMarketplace;
